import Popups from '@/components/popup/components/enums.ts';
import Modals from '@/components/modal/components/enums.ts';

export function useAllModals() {
  const { openPopup } = usePopups();
  const { openModal } = useModals();
  const openError = (props: any) => {
    openPopup(Popups.error.component, { ...Popups.error.props, ...props });
  };

  const openCheckout = (props: any) => {
    openModal(Modals.checkout.component, { ...Modals.checkout.props, ...props });
  };

  const openNewCheckout = (props?: any) => {
    openModal(Modals.newCheckout.component, { ...Modals.newCheckout.props, ...props });
  };

  const openChangeEmail = (props: any) => {
    openModal(Modals.changeEmail.component, { ...Modals.changeEmail.props, ...props });
  };

  return {
    openError,
    openCheckout,
    openChangeEmail,
    openNewCheckout,
  };
}
